export default "__VITE_ASSET__SZLi9oaF__"